import React from 'react'
import {
  LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, BarChart, Bar
} from 'recharts';

const CustomTooltip = ({ active, payload, state }) => {
  try {
    if (active) {
      return (
        <div className="custom-tooltip">
          {
            payload.map(p => {
              const i = parseInt(p.dataKey.split('-')[1])
              return (
                <div className='legend-container' key={'key-tooltip-' + p.dataKey}>
                  <div className='legend-circle' style={{ backgroundColor: state.lines.filter(f => f.i === i).reduce((pre, cur) => cur.color, '') }}></div>
                  {p.value}
                </div>
              )
            })
          }
        </div>
      );
    }
  } catch (error) { console.log(error) }
  return null;
};

const setData = (state) => {
  let month = JSON.parse(JSON.stringify(state.filter.month))
  if (!month.length) month = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
  let resp = []
  for (let i = 0; i < month.length; i++) {
    let item = { id: month[i] }
    state.lines.filter(l => l.eye).forEach(line => {
      line.data.forEach(data => {
        data.dataSet.filter(f => f.id === month[i]).forEach(set => {
          item = {
            ...item,
            name: set.name,
            ['line-' + line.i]: set.value
          }
        });
      });
    });
    resp.push(item)
  }
  return resp
}

const LineGraphic = ({ state }) => {
  const width = 620;
  const height = 300;
  const margin = { top: 10, right: 30, left: 20, bottom: 5, };
  const label = state.chartTags && { position: 'top', fontSize: 10 };
  return (
    <>
      {
        state.chartType === 'line' ?
          <LineChart
            width={width}
            height={height}
            data={setData(state)}
            margin={margin}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="name" />
            <YAxis />
            <Tooltip content={<CustomTooltip state={state} />} />
            {
              state.lines.filter(l => l.eye).map(line => <Line connectNulls type="monotone" dataKey={'line-' + line.i} stroke={line.color} label={label} key={'line-data-key-' + line.i}/>)
            }
          </LineChart> :
          <BarChart
            width={width}
            height={height}
            data={setData(state)}
            margin={margin}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="name" />
            <YAxis />
            <Tooltip content={<CustomTooltip state={state} />} />
            {
              state.lines.filter(l => l.eye).map(line => <Bar dataKey={'line-' + line.i} fill={line.color} label={label} />)
            }
          </BarChart>
      }
    </>
  )
}

export default LineGraphic;
